import styles from "./index.module.scss";
import {ReactComponent as CloseBtn} from "../Images/closeBtn.svg";
import {ReactComponent as ClockIcon} from "../Images/clock.svg";
import {ReactComponent as PresentIcon} from "../Images/present.svg";
import {ReactComponent as ProfileIcon} from "../Images/profile.svg";
import {ReactComponent as Fold} from "assets/image/Layout/PropertyPanel/ic_dropdown_fold.svg";
import {ReactComponent as Unfold} from "assets/image/Layout/PropertyPanel/ic_dropdown_unfold.svg";
import {ReactComponent as Check} from "assets/image/Common/ic_check_white.svg";
import SelectDropDown from "../SelectDropDown";
import {useEffect, useState} from "react";
import {REGION_DATA} from "../list";

function SchoolSelect({setSchoolData, dismiss}) {
  const [dropdownOpened, setDropdownOpened] = useState(null);
  const [currentZone, setCurrentZone] = useState(null);
  const [currentState, setCurrentState] = useState(null);
  const [currentSchoolList, setCurrentSchoolList] = useState(null);
  const [currentSchool, setCurrentSchool] = useState(null);

  useEffect(() => {
    setCurrentState(null);
    setCurrentSchool(null);
  }, [currentZone]);

  useEffect(() => {
    setCurrentSchool(null);
  }, [currentState]);

  const searchSchool = () => {
    if (!currentState) return;
    const currentSearchData = {
      zone: currentZone.name,
      state: currentState.name,
      schools: currentState.values,
    };
    setCurrentSchoolList(currentSearchData);
  };

  const handleClose = () => {
    dismiss();
  };

  return (
    <>
      <div className={styles.container}>
        <CloseBtn className={styles.close_btn} onClick={handleClose} />
        <div className={styles.contents_wrapper}>
          <div className={styles.title}>{TITLE}</div>
          <div className={styles.description}>
            <div>{DESC_1}</div>
            <div>{DESC_2}</div>
          </div>
          <div className={styles.tags_wrapper}>
            <div className={styles.tag_wrapper}>
              <ClockIcon className={styles.tag_icon} />
              <div className={styles.tag_desc}>Sehingga 20 November 2023</div>
            </div>
            <div className={styles.tag_wrapper}>
              <PresentIcon className={styles.tag_icon} />
              <div className={styles.tag_desc}>Hadiah Diberikan Mengikut Ranking Sekolah</div>
            </div>
            <div className={styles.tag_wrapper}>
              <ProfileIcon className={styles.tag_icon} />
              <div className={styles.tag_desc}>Hadiah Peserta Diberikan</div>
            </div>
          </div>
          <div className={styles.dropdown_wrapper}>
            <SelectComponent
              dropdownOpened={dropdownOpened}
              setDropdownOpened={setDropdownOpened}
              currentSelected={currentZone}
              setCurrentSelected={setCurrentZone}
              name={"ZON"}
              array={REGION_DATA}
            />
            <SelectComponent
              dropdownOpened={dropdownOpened}
              setDropdownOpened={setDropdownOpened}
              currentSelected={currentState}
              setCurrentSelected={setCurrentState}
              name={"NEGERI"}
              array={currentZone ? currentZone.values : []}
            />
            <button className={styles.search_btn} onClick={searchSchool}>
              Cari
            </button>
          </div>
          <div className={styles.list_container}>
            <div className={styles.item_title_wrapper}>
              <div className={styles.item_zone}>ZON</div>
              <div className={styles.item_state}>NEGERI</div>
              <div className={styles.item_school}>SEKOLAH</div>
            </div>
            {currentSchoolList &&
              currentSchoolList.schools.map(item => {
                return (
                  <SchoolListItem
                    key={item}
                    zone={currentSchoolList.zone}
                    state={currentSchoolList.state}
                    school={item}
                    setSchoolData={setSchoolData}
                    setCurrentSchool={setCurrentSchool}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
}

const SelectComponent = ({dropdownOpened, setDropdownOpened, currentSelected, setCurrentSelected, name, array}) => {
  return (
    <>
      <div
        className={`${styles.dropdown}
              ${dropdownOpened === name ? styles.dropdown_on : "off"}`}
        onClick={e => {
          e.stopPropagation();
          setDropdownOpened(dropdownOpened === name ? null : name);
        }}
      >
        <p>{currentSelected ? currentSelected.name : name}</p>
        {dropdownOpened === name ? <Unfold /> : <Fold />}
      </div>
      {dropdownOpened === name && (
        <SelectDropDown
          className={styles.select_component}
          style={{
            width: "12.7vw",
            background: "#111A2E",
            right: "0px",
            top: "1.8vw",
          }}
        >
          {array.map((position, i) => (
            <div
              key={i}
              onClick={e => {
                e.stopPropagation();
                setCurrentSelected(position);
                setDropdownOpened(null);
              }}
              className={`${position.name === currentSelected ? styles.active : ""} ${styles.item}`}
            >
              {/* <Check className={position.name === currentSelected ? "" : styles.uncheck} /> */}
              {position.name}
            </div>
          ))}
        </SelectDropDown>
      )}
    </>
  );
};

const SchoolListItem = ({zone, state, school, setSchoolData, setCurrentSchool}) => {
  const schoolDataHander = () => {
    setSchoolData({zone: zone, state: state, school: school});
    setCurrentSchool({zone: zone, state: state, school: school});
  };

  return (
    <>
      <div className={styles.item_wrapper} onClick={schoolDataHander}>
        <div className={styles.item_zone}>{zone}</div>
        <div className={styles.item_state}>{state}</div>
        <div className={styles.item_school}>{school}</div>
      </div>
    </>
  );
};

const TITLE = "Eksplorasi Alam Meta Techlympics: Misi Hadiah Misteri";
const DESC_1 = "Sila kumpulkan bintang untuk meningkatkan mata sekolah saya.";
const DESC_2 = "Cara Memilih Sekolah: Pilih Zon dan Negeri, kemudian klik untuk mencari sekolah.";
export default SchoolSelect;
